export default class Cell{
    constructor(cell){
        this.number = cell.number;
        this.text = cell.text;
        this.style = cell.style;
    }
}